import React, { useState } from 'react'
import {  useDispatch } from 'react-redux'
import { change } from './counterColor'

const Color = () => {
    const dispatch = useDispatch()
    const [color, setColor]= useState('white')
  return (
    <>
        <input type="text" onChange={(e)=>
            setColor(e.target.value)
        } />
        <button onClick={()=>{
            dispatch(change(color))
        }} >Change Color</button>
    </>
  )
}

export default Color